import React, { Component } from 'react';
import URL from '../../flux/path';
import axios from 'axios';
import $ from 'jquery';
import { HashLink as Link } from 'react-router-hash-link';
import {
	Carousel,
	CarouselItem,
	CarouselControl,
	CarouselIndicators,
	CarouselCaption
  } from 'reactstrap';

import Footer 	from '../footer/footer';
  
export default class Pages extends Component{
	constructor(props){
		super(props);
		this.state = { pages: [], id: this.props.match.params.id, video: [], gallery: '', count: 0 }
		$('#its').empty();
	}
	getPages( id ){
		axios.get( URL.pages + '?slug=' + id )
		.then( res => {
			this.setState({ pages: res.data });
			this.setState({ id: this.props.match.params.id });
			if( res.data[0] != undefined ){
				this.setState({ video: res.data[0].link_youtube });
				console.log( res.data[0].gallery.length );
				this.setState({ gallery: res.data[0].gallery });
			}
		});
	}
	componentWillReceiveProps(nextProps){
		if( this.state.id !== nextProps.match.params.id ){
			$('#its').empty();
			this.setState({ id: nextProps.match.params.id })
			this.getPages( nextProps.match.params.id );
			this.componentDidMount( nextProps.match.params.id );
		}
	}
	componentDidMount( id ){
		$('body').css('margin-bottom', '0');
		$('#its').empty();
		if( id !== undefined ){
			this.getPages( id );
		} else {
			this.getPages( this.state.id );
		}
	}
	render(){
		let item_to_use = null;
	
		if( !this.state.pages[0] ){
			return false;
		}
		{
			if( this.state.video != '' && this.state.video != null ){
				item_to_use = (
					<div className="item-video">
						<iframe id="ytplayer" width="560" height="315" src={'https://www.youtube.com/embed/' + this.state.video + '?rel=0&amp;controls=0&amp;showinfo=0'} frameBorder="0" allowFullScreen></iframe>
					</div>
				)
			} else if( this.state.gallery != '' && this.state.gallery != null ){
				item_to_use = (
					<div id="carouselControls" className="carousel slide item-slide" data-ride="carousel">
						<div className="carousel-inner" role="listbox">
							{
								this.state.gallery.map((image, index) => {
									if( index == 0 ){
										return(
											<div className="item active carousel-item">
												<img className="d-block img-fluid" src={image.imagem} alt="First slide" />
											</div>
											)
									} else {
										return (
											<div className="item carousel-item">
												<img className="d-block img-fluid" src={image.imagem} alt="First slide" />
											</div>
										)
									}
								})
							}
						</div>
						{
							this.state.gallery.map((image, index) => {
								if( this.state.gallery.length > 1 ){
									return (
										<div>
											<a className="carousel-control-prev" href="#carouselControls" role="button" data-slide="prev">
												<span className="icon-arrow-left" aria-hidden="true"></span>
												<span className="sr-only">Previous</span>
											</a>
											<a className="carousel-control-next" href="#carouselControls" role="button" data-slide="next">
												<span className="icon-arrow-right" aria-hidden="true"></span>
												<span className="sr-only">Next</span>
											</a>
										</div>
									)			
								}
							})
						}
					</div>
				)
			} else {
				item_to_use = <div />
			}
		}
		return(
			<div>
				<article>
					<section className="section-container post page">
						<div className="container-fluid h-100">
							<div className="row align-items-center h-100 relative">
								<div className="col-18 col-xl-6 offset-xl-2 relative">
									<div className="post-body-container">
										<div className="post-body">
											<h1>
											{this.state.pages[0].title.rendered}
											</h1>
											<div dangerouslySetInnerHTML={{ __html: this.state.pages[0].content.rendered }} />
										</div>
									</div>
									<div className="question-mark d-none">Queres viver<br/>num <span>mundo</span><br/>melhor?</div>
								</div>
								<div className="section-fixed page">
									<div class="container-fluid h-100">
										<div className="row justify-content-center align-items-center h-100" id="its">
											{item_to_use}
										</div>
									</div>
								</div>
							</div>
						</div>
					</section>
				</article>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/pages/estaticas.js